export const RECENT_GIFT_MONTH_FILTER_OPTIONS = [
	{ label: 'Gifts within 1 month', value: 1 },
	{ label: 'Gifts within 3 months', value: 3 },
];



// WEBPACK FOOTER //
// ./src/utils/recentGiftMonthFilterOptions.js